require('./angular/app');
require('./angular/controllers/AdvancedFiltersModalCtrl.js');
require('./angular/controllers/PitchSearchCtrl.js');
require('./angular/controllers/PitchSearchFormCtrl.js');
require('./angular/controllers/SearchFiltersCtrl.js');
require('./angular/services/AdvancedFiltersModal.js');
require('./angular/services/SearchRequestInterceptor.js');
// require('./angular/services/PitchSearchConfig.js');
require('./angular/services/ACLInterceptor.js');
require('./angular/services/Label.js');


// WEBPACK FOOTER //
// ./src/SearchClientBundle/Resources/js/index.js